<div
  class="sidebar"
  [class.sidebar_is-collapsed]="isSideBarCollapsed()"
  bluClickOutside
  (clickedOutside)="setIsSideNavBarVisible(false)"
>
  <div
    data-auto-id="toggleCollapseClick"
    class="sidebar__toggle"
    (click)="toggleCollapse()"
  ></div>
  <div class="sidebar__user-info">
    <app-user-menu />
  </div>
  <div class="sidebar__nav">
    <app-nav-bar />
  </div>
</div>
